import React from 'react'
import CreateHotelWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import HotelForm from '../components/form/form.component'
import HotelImages from '../components/images/images.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import './create.styles.scss'

class CreateHotel extends React.Component {

    constructor(props) {
        super(props)
        this.createHotelWorker = CreateHotelWorker(this)
        this.state = this.createHotelWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createHotelWorker.isValid() && this.createHotelWorker.createHotel()
    }

    onCancel = () => this.props.history.push('/content/hotels')

    render() {
        return (
            <div className="create-hotel">
                {
                    this.state.creatingHotel && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/hotels">Hotels</Link>
                    <div className="header">
                        <h4>Create Hotel</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <HotelForm {...this.state} action="Add Hotel" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <HotelImages hotelId={this.state.id} images={this.state.images} />
                    </HotelForm>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateHotel)
